import {
  DivRegistrationResult,
  PdfPageContent,
  buildResult,
  extractSection,
  fieldValue,
  getBlocks,
  joinPages
} from './pdfParser';

/** inMotiv Autoconnect WEBDIV aanvraag (twee kolommen: links voertuig, rechts eigenaar). */
export function parseInmotiv(pages: PdfPageContent[]): DivRegistrationResult {
  const text = joinPages(pages);
  const leftText = joinPages(pages, 'left');
  const rightText = joinPages(pages, 'right');
  const blocks = getBlocks(leftText);

  const ownerSection =
    extractSection(rightText, 'Eigenaar', [
      'Voorste nummerplaat',
      'Ingeschreven door'
    ]) ||
    extractSection(text, 'Eigenaar', [
      'Voorste nummerplaat',
      'Ingeschreven door'
    ]);

  const regSection = extractSection(leftText, 'Registratiegegevens', [
    'Gegevens voor de registratie',
    'Gegevens voertuig'
  ]);
  const insuranceSection =
    extractSection(leftText, 'Gegevens verzekeringsmaatschappij', [
      'Gegevens voertuig'
    ]) ||
    extractSection(leftText, 'Gegevens verzekeringmaatschappij', [
      'Gegevens voertuig'
    ]);

  return buildResult({
    text: leftText,
    blocks,
    // Vehicle labels sit in the left column but values in the right — search full page.
    vehicleSource: text,
    policyholderSection: ownerSection,
    vehicleBlocks: ['GEGEVENS VOERTUIG'],
    plateLabels: ['Plaatnummer'],
    plateBlocks: ['REGISTRATIEGEGEVENS', 'GENERAL'],
    plateSection: regSection,
    brandLabels: ['Merk - Voertuigtype', 'Merk – Voertuigtype'],
    natureLabels: ['Soort voertuig'],
    categoryLabels: ['Categorie'],
    insurerSection: insuranceSection,
    insurerLabels: ['Verzekeringsmaatschappij', 'Verzekeringmaatschappij'],
    insurerBlocks: [
      'GEGEVENS VERZEKERINGSMAATSCHAPPIJ',
      'GEGEVENS VERZEKERINGMAATSCHAPPIJ'
    ],
    insurerRegex: /Verzekering(?:s)?maatschappij\s*:?\s*([^\n]+)/i,
    dateLabels: ['Begindatum verzekering', 'Registratiedatum'],
    dateBlocks: [
      'GEGEVENS VERZEKERINGSMAATSCHAPPIJ',
      'GEGEVENS VERZEKERINGMAATSCHAPPIJ',
      'REGISTRATIEGEGEVENS'
    ],
    dateExtra: [fieldValue(insuranceSection, 'Begindatum verzekering')]
  });
}

export function isInmotivDocument(text: string): boolean {
  return /WEBDIV|Autoconnect|inMotiv/i.test(text);
}
